// Enable API mocking in development mode only
export async function enableMocking(): Promise<void> {
  if (import.meta.env.DEV) {
    const { worker } = await import('./browser');
    const { initializeDb } = await import('./db');

    initializeDb();
    // Start the worker and log when it's ready
    await worker.start({
      onUnhandledRequest: 'bypass',
    });
  }
}

export { handlers } from './handlers';
export { worker } from './browser';
